const CONFIG = {
  WAQI_BASE_URL: 'https://api.waqi.info/',
  AIRWATCH_ARTICLES_BASE_URL: 'https://airwatchid-back-end.vercel.app',
  TOKEN: process.env.WAQI_API_KEY,
};

export default CONFIG;
